<template>

  <router-view/>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: 'App',
  watch: {
      $route(to) {
          document.title = to.meta.title || 'Andamento da Obra';
      },
  },
  created() {
    this.fetchData();
  },
  computed: {
    ...mapGetters(["datas"]),
  },
   methods:{
     ...mapActions(["fetchData"]),
  }
};
</script>
<style src="./assets/styles/app.css" />
